module.exports = "<aside class=\"as-sidebar as-sidebar--<%= position %>\"></aside>\n"